/* eslint-disable no-console, react/no-render-return-value */
import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import 'core-js/stable';
import * as React from 'react';
import { ReactComponentElement } from 'react';
import * as ReactDOM from 'react-dom';
import { AppContainer } from 'react-hot-loader';
import './services/ErrorReportingService';
import routes from './routes';

// !! DO NOT REMOVE THIS COMMENT !!
// List of Piñata icons that are not referenced in Fastflow, but needs to be loaded because it's used in dependency projects:
// IconName.CANCEL

const render = (component: ReactComponentElement<any>) =>
  ReactDOM.render(
    <AppContainer>{component}</AppContainer>,
    document.getElementById('react-app'),
  );
render(routes);
if (module.hot) {
  // tslint:disable-next-line no-console
  console.log('module.hot is present');
  module.hot.accept('./routes', () => {
    const reloadableRoutes = require('./routes').default; // eslint-disable-line @typescript-eslint/no-var-requires
    render(reloadableRoutes);
  });
}
